<template>
    <div class="authorized">
        <el-popover
            :placement="placement"
            trigger="click"
            v-model="authorizedStore"
            @show="platform_id = null"
        >
            <div class="store-items-grid">
                <div
                    class="store-item"
                    :class="{ active: item.id == platform_id }"
                    v-for="item of platformListCp"
                    :key="item.id"
                    @click="chiocePlatform(item)"
                >
                    <div class="store-item-icon">
                        <img
                            :src="
                                require(`@/assets/image/store/${item.code}.png`)
                            "
                        />
                    </div>
                    <p>{{ item.name }}</p>
                    <!-- <img
                        :src="
                            require('@/assets/image/goods/' +
                                item.code +
                                '.png')
                        "
                    /> -->
                </div>
            </div>
            <!-- <p slot="reference">Authorized store</p> -->
            <!-- <img
                slot="reference"
                src="@/assets/image/store.svg"
                class="store-img"
            /> -->
            <slot slot="reference"></slot>
        </el-popover>
        <add
            :addVisible.sync="addVisible"
            :id="platform_id"
            :user_id="tableItem && tableItem.id"
            @successCloseDialog="successCloseDialog"
        ></add>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import add from "@/views/pages/storePlatform/storeList/add";
export default {
    inject: ["saleUserList"],
    data() {
        return {
            platform_id: null,
        };
    },
    components: {
        add,
    },
    computed: {
        ...mapState({
            menu_id: (state) => state.menu.menu_id,
        }),
        platformListCp(){
            return this.platformList.filter(item => item.status === 1)
        }
    },
    props: {
        tableItem: Object,
        platformList: Array,
        placement: {
            default: "bottom-start",
            type: String,
        },
    },
    methods: {
        chiocePlatform(item) {
            this.platform_id = item.id;
            this.addVisible = true;
            this.authorizedStore = false;
            this.$emit("rowDo", item);
        },
        successCloseDialog(row) {
            this.authVisible = true;
            this.tableItem = row;
            if (row.platform_id == 3) {
                this.authKeyList = [
                    { key: "appid", name: "AppId" },
                    { key: "secret", name: "Secret" },
                    { key: "access_token", name: "Access Token" },
                    { key: "shop", name: "Shop" },
                ];
            } else if (row.platform_id == 4) {
                this.authKeyList = [
                    { key: "AppKey", name: "AppKey" },
                    { key: "AppSecret", name: "AppSecret" },
                    { key: "Token", name: "Token" },
                    { key: "ShopURL", name: "Shop URL" },
                ];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.authorized {
    display: flex;
    align-items: center;
    cursor: pointer;
    p {
        font-size: 18px;
        // font-weight: bold;
        margin-left: 30px;
    }
}

.store-items {
    display: flex;
    flex-wrap: wrap;
    padding: 30px;
    .store-item {
        width: 140px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #f3f3f3;
        border-radius: 6px;
        box-sizing: border-box;
        // margin: 0 30px 30px 0;
        cursor: pointer;
        img {
            width: 60%;
        }
        &:last-child {
            margin-right: 0;
        }
        &:hover {
            box-shadow: 0 0 5px 0 rgba(200, 200, 200, 0.6);
        }
    }
    .active {
        border-color: $color-primary;
    }
    .shopify {
        img {
            width: 70%;
        }
    }
    .etsy {
        img {
            width: 40%;
        }
    }
    .amazon {
        img {
            width: 50%;
        }
    }
    .ebay {
        img {
            width: 45%;
        }
    }
}

.store-items-grid {
    display: grid;
    padding: 10px;
    grid-gap: 10px;
    grid-template-columns: repeat(2, 270px);
    .store-item {
        display: flex;
        align-items: center;
        padding: 10px 16px;
        transition: color 0.4s;
        .store-item-icon {
            background: #f7f7f7;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        &:hover {
            cursor: pointer;
            background: #efefef;
            border-radius: 8px;
            color: $color-primary;
        }
    }
}
</style>